<template>
    <div>
        <div style="display: inline-block; width: 100%;" ref="trigger">
        <slot>
            <ui-button 
                :disabled="disabled"
                icon="face" 
                style="width: 100%; margin-bottom: .5rem; justify-content: left;"
            >Assign</ui-button>
        </slot>
        </div>
        <ui-popover ref="assignPopover" :trigger="$refs.trigger" v-show="!disabled" :close-on-scroll="false">
            <div style="width:100%; background:#f8f8f8; padding: .8rem 1rem;">Team Member</div>
            <div style="padding: 1rem; width: 15rem;">
                <div v-if="!isLoadingUsers">
                    <ui-select 
                        has-search
                        placeholder="Select team member" 
                        v-model="selected" 
                        :options="users" 
                        :keys="{ label: 'name', value: 'id' }"
                    ></ui-select>
                    <ui-button :loading="isLoading" @click="save">Save</ui-button>
                    <ui-button v-show="selected && selected.id" :disabled="isLoading" @click="destroy" color="red">Remove</ui-button>
                </div>
                <div v-else>
                    <ui-progress-circular :indeterminate="true" style="margin: auto;" />
                </div>
            </div>
        </ui-popover>
    </div>
</template>

<script>
    import { UserResource, UserSchema } from '../../../classes/Api/User'

    export default {
        props: {
            isLoading: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            user: {},
            disabled: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            id: {
                default() {
                    return Math.random();
                }
            },
            team: {
                default: null,
            }
        },
        watch: {
            user: {
                handler: function(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.selected = newVal ? newVal : {};
                    }
                },
                deep: true,
            }
        },
        data() {
            return {
                selected: {},
                users: [],
                isLoadingUsers: false,
            }
        },
        created() {
            let params = { filters: JSON.stringify({ "user.is_active": true }) };

            if (this.team) {
                params.team = this.team;
            }

            this.isLoadingUsers = true

            UserResource.all(params).then(response => {
                this.users = response.data;
                if (this.user) {
                    this.selected = this.user;
                }

                this.isLoadingUsers = false
            }, handleApiError);
        },
        methods: {
            save() {
                this.$emit('save', Object.assign({}, this.selected));
            },
            destroy() {
                this.$emit('save', new UserSchema());
            },
            close() {
                this.$refs['assignPopover'].close();
            },
        }
    }
</script>